import { fetchAuthSession } from "aws-amplify/auth";

const decodeJwtPayload = (jwt: string): { exp?: number } | null => {
  const [, payload] = jwt.split(".");
  if (!payload) return null;
  const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
  return JSON.parse(json) as { exp?: number };
};

const SKEW_MS = 2 * 60 * 1000; // refresh if <2 mins left
let refreshInFlight: null | Promise<null | string> = null;

export const getValidAccessToken = async (): Promise<null | string> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString() ?? null;
  if (!token) return null;

  const exp = decodeJwtPayload(token)?.exp;
  const expMs = exp ? exp * 1000 : 0;

  // If token is valid for > skew, use it
  if (expMs && expMs - Date.now() > SKEW_MS) return token;

  // Otherwise refresh (dedup)
  if (!refreshInFlight) {
    refreshInFlight = fetchAuthSession({ forceRefresh: true })
      .then((s) => s.tokens?.accessToken?.toString() ?? null)
      .finally(() => {
        refreshInFlight = null;
      });
  }

  return refreshInFlight;
};
